import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Container, Row, Col, Button, Spinner } from 'react-bootstrap';
import { NumbersOnlyUtil } from '../../utils';
import { DataContext } from '../../adapter';
import styled from 'styled-components';
import { OtpGenerateService, OtpValidateService } from '../../domain';
import Swal from 'sweetalert2';
import OtpModalComponent from '../components/modalOtp';

const StyledContainer = styled(Container)`
    font-family: Montserrat, sans-serif;
    color: rgba(41, 37, 97, 1);
    background: rgb(234, 222, 208, 1);
    padding: 0 15% !important;

    @media (min-width: 300px) and (max-width: 767px) {
        padding: 0 10% !important;
    }
`;

const Title = styled.h1`
    font-size: 42px;
    font-weight: 700;
    margin-top: 40px;

    @media (min-width: 300px) and (max-width: 767px) {
        margin-top: 20px;
    }
`;

const StyledRow = styled(Row)`
    padding: 6px 0;
`;

const Description = styled.p`
    font-size: 22px;
    font-weight: 500;
    padding: 5px 0px;
`;

const SubDescription = styled.p`
    font-size: 17px;
    font-weight: 400;
    color: black;
`;

const SubDesc = styled.p`
    font-size: 17px;
    font-weight: 400;
    color: black;
`;

const RequiredTag = styled.span`
    color: #B01116;
`;

const ErrorDisplay = styled.ul`
    color: red;
`;

const StyledForm = styled(Form)`
    .form-group-label {
        font-size: 22px;
        font-weight: 500;
        padding: 8px 0px;
    }
`;

const StyledSubmitButton = styled(Button)`
    background-color: rgba(176, 17, 22, 1);
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: Montserrat, sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: white;
    text-align: left;
    margin-bottom: 40px;

    @media (min-width: 300px) and (max-width: 500px) {
        margin-bottom: 20px;
    }
`;

const Loading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2000;
`;

const InfoContainer = styled.div`
    position: relative;
    display: inline-block;
    cursor: pointer;

    &:hover .info-description {
        display: block;
    }
`;

const StyledDescription = styled.p`
    font-style: italic;
    font-size: 14px;
    color: black;
    display: none;
    position: absolute;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 500px;
    z-index: 100;
    top: -60px;
    left: -220px;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 300px;
        left: -140px;
        top: -95px;
    }
`;

const StyledDescription2 = styled.p`
    font-style: italic;
    font-size: 14px;
    color: black;
    display: none;
    position: absolute;
    background: rgba(255, 255, 255, 1);
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 550px;
    z-index: 100;
    top: -60px;
    left: -220px;

    @media (min-width: 300px) and (max-width: 500px) {
        width: 300px;
        left: 0;
        top: -95px;
    }
`;

export default function Home() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({});
    const [formDataError, setFormDataError] = useState(null);
    const { claimsData, updateClaimsData, clearClaimsData } = DataContext();
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false); // Modal visibility state
    const [response, setResponse] = useState(null);

    const _OtpGenerateService = new OtpGenerateService();
    const _OtpValidateService = new OtpValidateService();

    // Function to handle OTP modal visibility
    const handleOpenModal = (response) => {
        setModalVisible(true);
        setResponse(response);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setResponse(null);
    };

    const validateFormData = async (type = null) => {
        const { loanAccountNumber } = formData;

        console.log('otp valid', claimsData?.otpData?.isOtpValidated === undefined);

        if (claimsData?.otpData?.isOtpValidated === undefined) {
            if (!loanAccountNumber) {
                Swal.fire({
                    text: 'Please provide Loan Account Number',
                    icon: 'error',
                    iconColor: 'black',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Ok',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                });
                return { isValid: false };
            }

            if (formData.loanAccountNumber) {
                setLoading(true);

                const setOtpGeneratePayloadLAN = {
                    loanAccountNumber: formData.loanAccountNumber,
                    type: type
                };

                const response = await _OtpGenerateService.execute(setOtpGeneratePayloadLAN);
                // const response = await _UploadedPolicyGetService.execute(formData);
                if (response?.status === 'failed' && response?.message === 'No policy found') {
                    Swal.fire({
                        html: `
                            <div style="text-align: center; font-family: Montserrat, sans-serif;">
                            <p style="font-weight: bold; color: #342855; font-size: 16px; margin-top: 20px;">Oops! The Submitted Number Cannot Be Verified</p>
                            <p style="color: #1B1464; font-size: 14px; font-weight: 400;">Siguraduhing tama ang iyong Loan Account Number.</p>
                            </div>
                             `,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'BACK',
                        customClass: {
                            popup: 'my-popup',
                            confirmButton: 'my-confirm-button',
                            cancelButton: 'my-cancel-button'
                        }
                    }).then((result) => {
                        clearClaimsData();
                        setFormData({});
                    });
                    setLoading(false);
                    return { isValid: false };
                } else {
                    setLoading(false);
                    handleOpenModal({ response: response?.data });
                    return { isValid: true, isOtpValid: false };
                }
            }

            return {
                isValid: true
            };
        } else {
            return {
                isValid: true
            };
        }
    };

    const handleFormSubmit = async (e, type = null) => {
        e.preventDefault();

        const { isValid } = await validateFormData(type);

        if (isValid && claimsData?.otpData?.isOtpValidated) {
            console.log('claimsData', claimsData);
            // handleShowData();
        }
        console.log('isValid', isValid);
    };

    // must add value in localStorage...
    const handleOtpSubmit = async (type, otp) => {
        try {
            let setOtpValidatePayload;
            if (formData?.loanAccountNumber) {
                setOtpValidatePayload = {
                    loanAccountNumber: formData?.loanAccountNumber,
                    type,
                    otp
                };
            } else {
                setOtpValidatePayload = {
                    email: formData?.email,
                    mobileNo: formData?.mobileNo,
                    type,
                    otp
                };
            }

            const otpResult = await _OtpValidateService.execute(setOtpValidatePayload);

            return otpResult;
        } catch (error) {
            console.error('error occured: ', error);
            Swal.fire({
                text: 'Something went wrong. Please try again later.',
                icon: 'error',
                iconColor: 'black',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
        }
    };

    const handleShowData = async (uploadedPolicies) => {

        try {
            setLoading(true);
            const policy = uploadedPolicies.policy;
            console.log("policy", policy)

            if(policy.message === 'Policy still active but eligible for renewal.' && policy.isEligibleForRenewal === true || policy.message === 'Policy is expired and eligible for renewal.' && policy.isEligibleForRenewal === true) {
                updateClaimsData({policy});
                navigate('/kyc');

                return;
            }
            
            if(policy.message === 'Old policy has been submitted.' && policy.isEligibleForRenewal === false) {
                Swal.fire({
                    html: `
                        <div style="text-align: center; font-family: Montserrat, sans-serif;">
                        <p style="font-weight: bold; color: #342855; font-size: 16px; margin-top: 20px;">Lumang Loan Account Number ang Ginamit</p>
                        <p style="color: #1B1464; font-size: 16px; font-weight: 400;">Napansin naming ginagamit mo ang lumang Loan Account Number (o LAN) para sa renewal. Mangyaring gamitin ang pinakabagong LAN upang maiproseso ang iyong renewal nang maayos.</p>
                        </div>
                         `,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'BACK',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                }).then((result) => {
                    clearClaimsData();
                    setFormData({});
                    window.location.reload();
                });
            }

            if(policy.message === 'Policy still active.' && policy.isEligibleForRenewal === false) {
                Swal.fire({
                    html: `
                        <div style="text-align: center; font-family: Montserrat, sans-serif;">
                        <p style="font-weight: bold; color: #342855; font-size: 16px; margin-top: 20px;">Your Home Protection Insurance Is Active</p>
                        <p style="color: #1B1464; font-size: 14px; font-weight: 400;">Maari lamang mag-renew ng Home Protection Insurance 45 days bago mag-expire ang inyong current policy.</p>
                        <p style="color: #1B1464; font-size: 14px; font-weight: 400;">Siguraduhing sumubok muli bago matapos ang inyong current coverage upang maka-iwas sa anumang abala.</p>
                        </div>
                         `,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'BACK',
                    customClass: {
                        popup: 'my-popup',
                        confirmButton: 'my-confirm-button',
                        cancelButton: 'my-cancel-button'
                    }
                }).then((result) => {
                    clearClaimsData();
                    setFormData({});
                    window.location.reload();
                });
            }
            
        } catch (error) {
            console.error('Error: ', error);
            Swal.fire({
                html: `
                    <div style="text-align: center; font-family: Montserrat, sans-serif;">
                    <p style="font-weight: bold; color: #342855; font-size: 16px; margin-top: 20px;">Oops! The Submitted Number Cannot Be Verified</p>
                    <p style="color: #1B1464; font-size: 14px; font-weight: 400;">Siguraduhing tama ang iyong Loan Account Number.</p>
                    </div>
                     `,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'BACK',
                customClass: {
                    popup: 'my-popup',
                    confirmButton: 'my-confirm-button',
                    cancelButton: 'my-cancel-button'
                }
            });
            setLoading(false);
            // setFormData({});
            handleCloseModal();
            window.location.reload();
        }
    };

    useEffect(() => {
        if (Object.keys(claimsData).length === 1 && Object.keys(claimsData)[0] === 'otpData') {
            clearClaimsData();
        }

        if (Object.keys(claimsData).length) {
            setFormData({ ...claimsData });
        }
    }, []);

    return (
        <>
            {loading && (
                <Loading>
                    <Spinner animation="border" variant="light" />
                </Loading>
            )}
            <StyledContainer id="claim" fluid>
                <StyledRow>
                    <Title>Let’s get you covered!</Title>
                    <SubDescription>I-verify ang iyong Loan Account Number para makapagsimula</SubDescription>
                </StyledRow>
                <StyledForm>
                    {formDataError && (
                        <Row>
                            <Col>
                                <Description className="mb-0">Please check the inputs again.</Description>
                                <ErrorDisplay>
                                    {formDataError &&
                                        formDataError.map((item, index) => {
                                            return <li key={'errorKey_' + index}>{item.message}</li>;
                                        })}
                                </ErrorDisplay>
                            </Col>
                        </Row>
                    )}
                    <Row className="mb-4">
                        <Col lg={5}>
                            <Form.Group>
                                <Col className="form-group-label">
                                    LOAN ACCOUNT NUMBER/COIC Number<RequiredTag> *</RequiredTag>
                                    <InfoContainer>
                                        <i
                                            className="bi bi-info-circle"
                                            style={{ padding: '2px', fontSize: '18px' }}
                                        ></i>
                                        <StyledDescription2 className="info-description">
                                            How to check your Loan Account Number: Open your Home Credit App &gt; Go to
                                            the "Home" tab &gt; Go to "My Loans" to find your 10-digit Loan Account
                                            Number
                                        </StyledDescription2>
                                    </InfoContainer>
                                </Col>
                                <Form.Control
                                    type="text"
                                    size="lg"
                                    name="loanAccountNumber"
                                    placeholder="LOAN ACCOUNT NUMBER/COIC Number"
                                    value={formData.loanAccountNumber ?? ''}
                                    onChange={(e) =>
                                        setFormData((val) => ({
                                            ...val,
                                            loanAccountNumber :e.target.value
                                        }))
                                    }
                                    isValid={formData.loanAccountNumber && formData.loanAccountNumber.length >= 1}
                                    isInvalid={formData.loanAccountNumber && formData.loanAccountNumber.length < 1}
                                    disabled={formData?.availablePolicy}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <SubDesc>
                                A One-Time Password (OTP) will be sent to the mobile number/email address attached to
                                your loan application
                            </SubDesc>
                        </Col>
                    </Row>
                    <Row>
                        <div className="gap-2 justify-content-left mt-2">
                            {!!Object.keys(formData).length && (
                                <StyledSubmitButton
                                    className="btn-submit me-2"
                                    variant="secondary"
                                    type="button"
                                    onClick={(e) => {
                                        setFormData({});
                                        setFormDataError(null);
                                        clearClaimsData();
                                    }}
                                >
                                    CLEAR
                                </StyledSubmitButton>
                            )}
                            <StyledSubmitButton
                                className="btn-submit me-2"
                                variant="secondary"
                                type="button"
                                onClick={(e) => {
                                    handleFormSubmit(e);
                                }}
                            >
                                SUBMIT
                            </StyledSubmitButton>
                        </div>
                    </Row>
                </StyledForm>
                <OtpModalComponent
                    showModal={isModalVisible}
                    onClose={handleCloseModal}
                    response={response}
                    formData={formData}
                    setFormData={setFormData}
                    handleShowData={handleShowData}
                    handleFormSubmit={handleFormSubmit}
                    handleOtpSubmit={handleOtpSubmit}
                    setLoading={setLoading}
                    claimsData={claimsData}
                    updateClaimsData={updateClaimsData}
                />
            </StyledContainer>
        </>
    );
}
